module.exports = __webpack_public_path__ + "img/lc.b7bd19c4.png";